export default "__VITE_ASSET__Bkzh2p8V__"